<template>
  <el-footer height="50px">
    <div class="copyright">
      <a @click.stop.prevent="$router.push('/about-us')">{{ $t('footer.first') }}</a>
      <span>/</span>
      <a @click.stop.prevent="$router.push('/privacy-policy')">{{ $t('footer.second') }}</a>
      <span>/</span>
      <a @click.stop.prevent="$router.push('/disclaimer')">{{ $t('footer.third') }}</a>
      <span>/</span>
      <a @click.stop.prevent="$router.push('/terms')">{{ $t('footer.fourth') }}</a>
      <span>/</span>
      <a @click.stop.prevent="$router.push('/copyright')">{{ copyright }}</a>
    </div>
  </el-footer>
</template>

<script>
export default {
  computed: {
    copyright() {
      return this.$t('footer.fifth').replace('$', new Date().getFullYear())
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.el-footer {
  background: var(--theme);
  color: #fff;
  padding: 0;
  line-height: 50px;
  a {
    color: #fff;
    padding-right: 5px;
    cursor: pointer;
    &:hover {
      color: var(--r_theme);
    }
  }
}
</style>